import interactsWithModel from '@js/nal/vue-mixins/interactsWithModel.js';
import { isPrimaryOwnerUser, isSecondaryOwnerUser } from '@js/core/auth/helpers.js';
const secondaryOwnersGroupsMapping = {
    associated: 'user',
    office: 'officeGroup',
    region: 'region',
};
export default {
    mixins: [
        interactsWithModel,
    ],
    computed: {
        isInvoice() {
            return this.type ? this.type === 'invoice' : false;
        },
        isUserInOwnerOfficeGroup() {
            return this.nal.firm.office_groups?.some(({ user_ids }) =>
                user_ids.includes(this.nal.user.id) && user_ids.includes(this._model?.owner?.model?.id)
            );
        },
        isUserOwner() {
            return this._model
                ? isPrimaryOwnerUser(this.nal.user, this._model)
                : false;
        },
    },
    methods: {
        // Type is singular intentionally
        ableToSee(typeParam) {
            const type = typeParam || this.type;
            const key = type.plural() + '.view';
            return this.billingPermission(key);
        },
        ableToCreate(typeParam) {
            const type = typeParam || this.type;
            const key = type.plural() + '.create';
            return this.billingPermission(key);
        },
        ableToEdit(typeParam) {
            const type = typeParam || this.type;
            const key = type.plural() + '.edit';
            return this.billingPermission(key);
        },
        ableToPreview(templateType, isLocked) {
            const permittedPreviewTypes = ['pdf'];
            if (templateType) {
                return _.includes(permittedPreviewTypes, templateType);
            }
            return !isLocked;
        },
        ableToManage(typeParam) {
            const type = typeParam || this.type;
            const key = type.plural() + (this.isInvoice ? '.manage' : '.lock');
            return this.billingPermission(key);
        },
        ableToLock(typeParam) {
            const type = typeParam || this.type;
            const canManage = this.ableToManage(type);
            return this.isInvoice ? (canManage && this.hasBillingContact) : canManage;
        },
        ableToUnlock(typeParam) {
            const type = typeParam || this.type;
            const key = type.plural() + '.unlock';
            return this.billingPermission(key);
        },
        ableToDelete(typeParam) {
            const type = typeParam || this.type;
            const key = type.plural() + '.delete';
            return this.billingPermission(key);
        },
        // eslint-disable-next-line complexity
        billingPermission(key) {
            if (window.auth('billing.' + key + '.always')) {
                return true;
            }
            if (this._model) {
                if (['owned', 'associated', 'office', 'region', 'ownersOffice']
                    .some(group => window.auth('billing.' + key + '.' + group)
                        && (group === 'ownersOffice'
                            ? this.isUserInOwnerOfficeGroup
                            : group === 'owned'
                                ? this.isUserOwner
                                : isSecondaryOwnerUser(this.nal.user, this._model, [secondaryOwnersGroupsMapping[group]])
                        )
                    )
                ) {
                    return true;
                }
            }
            return false;
        },
    },
};
